import type { InProgressSessions } from '@hotjar/webapp/domains/recordings/model';
import {
  IN_PROGRESS_SESSION_QUERY_KEY,
  sessionsInProgress,
} from '@hotjar/webapp/domains/recordings/api/recordings';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

export const useInProgressSessions = ({
  siteId,
  selectRandom = false,
}: {
  siteId?: number;
  selectRandom?: boolean;
}): UseQueryResult<InProgressSessions, Error> =>
  useQuery(
    [IN_PROGRESS_SESSION_QUERY_KEY, siteId],
    () => sessionsInProgress(siteId as number, selectRandom),
    {
      enabled: !!siteId,
      refetchInterval: 10000,
      refetchIntervalInBackground: false,
    },
  );
